var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { HistoryCurveDisplayPeriodEnum } from '../../../../view-data/components/history-curve/general/history-curve-display-period-enum';
import { SelectDisplayItem } from '../../../shared/select-display-item';
var HistoryCurveDisplayPeriod = /** @class */ (function (_super) {
    __extends(HistoryCurveDisplayPeriod, _super);
    function HistoryCurveDisplayPeriod() {
        var _this = _super.call(this) || this;
        _this.push(new SelectDisplayItem('RecentHour', HistoryCurveDisplayPeriodEnum.RecentAnHour), new SelectDisplayItem('RecentOneDay', HistoryCurveDisplayPeriodEnum.RecentOneDay), new SelectDisplayItem('RecentWeek', HistoryCurveDisplayPeriodEnum.RecentSevenDays), new SelectDisplayItem('RecentMonth', HistoryCurveDisplayPeriodEnum.RecentThirtyDays), new SelectDisplayItem('RecentYear', HistoryCurveDisplayPeriodEnum.RecentOneYear));
        return _this;
    }
    return HistoryCurveDisplayPeriod;
}(Array));
export { HistoryCurveDisplayPeriod };
